import type { ApolloCache, ApolloClient } from '@apollo/client';

import { ListLoansDocument } from '../__generated__/graphql/api';
import { getLoanRefetchQuery } from '../components/LoanDetails/getLoanRefetchQuery';
import { invalidateApolloFields } from './apolloCacheInvalidation';

const LOANS_LIST_QUERY_NAME = 'listLoans';

const invalidateLoansList = (cache: ApolloCache<unknown>) => {
  invalidateApolloFields(cache, [LOANS_LIST_QUERY_NAME]);
};

export const getLoanMutationRefreshOptions = (loanId: string) => ({
  ...getLoanRefetchQuery(loanId),
  awaitRefetchQueries: true,
  update: invalidateLoansList,
});

/** @public */
export const refreshLoanAfterRestMutation = (apolloClient: ApolloClient<object>, loanId: string) => {
  const loanRefetchQuery = getLoanRefetchQuery(loanId);

  return apolloClient.refetchQueries({
    include: [...loanRefetchQuery.refetchQueries.map(({ query }) => query), ListLoansDocument],
    updateCache: invalidateLoansList,
  });
};
